export const visibleTicketTypes = (confirm, ticketTypes, promoCode, restrictedTicketTypeId, restrictedTicketGroupId) => {
  var now = new Date();
  var heldIds = new Set(ticketTypes.filter((tt) => tt.revealed_held_count > 0).map((tt) => tt.id));

  return ticketTypes.filter((tt) => {
    if(restrictedTicketGroupId && !(tt.ancestor_ids || []).includes(restrictedTicketGroupId)){
      return false;
    }

    var startTime = new Date(tt.start_time);
    var endTime = new Date(tt.end_time);

    var onSale = !confirm.sold_out;
    var unmanifested = tt.manifested === false;
    var notAtTheDoor = tt.sales_channel !== "At the door only";
    var visible = tt.visibility === "Visible";
    var showWhenOnSale = tt.visibility === "Hidden when not on sale" && startTime <= now && now <= endTime;
    var revealedByPromoCode = Object.keys(promoCode).length > 0
      && ((promoCode.reveal_all_hidden_tickets && promoCode.applies_to_ticket_types && !tt.pass_redemption)
        || (promoCode.ticket_type_ids
          && (promoCode.ticket_type_ids.includes(tt.id)
            || promoCode.ticket_type_ids.includes(tt.ticket_type_template_id)
            || promoCode.ticket_type_ids.includes(tt.price_parent_id))));
    var revealedByHold = heldIds.has(tt.id) || heldIds.has(tt.price_parent_id);

    var isRestrictionTarget = restrictedTicketTypeId
      && (tt.id === restrictedTicketTypeId || tt.ticket_type_template_id === restrictedTicketTypeId || tt.price_parent_id === restrictedTicketTypeId);

    if(restrictedTicketTypeId && !isRestrictionTarget && !revealedByPromoCode){
      return false;
    }

    return (
      notAtTheDoor
        && (onSale || unmanifested)
        && (visible || showWhenOnSale || revealedByPromoCode || isRestrictionTarget || revealedByHold)
        && tt.start_time
        && tt.end_time
    );
  });
}
